import React from 'react';

import type { InstagramStoryComponentsProps } from './types';

export function Footer(_props: InstagramStoryComponentsProps): React.JSX.Element {
	return <div>Instagram Story Footer</div>;
}
